import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";
import element from "./element/index";
import router from "./router";
import Layout from "./components/Layout.vue";

import { BootstrapVue } from "bootstrap-vue";

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
Vue.use(element);
new Vue({
  el: "#app",
  router,
  render: (h) => h(Layout),
});
